<template>
  <div
    class="stylist-card-simple jm-bg-white jm-py-4 jm-px-3"
    data-test="stylist-profile-card"
  >
    <div
      class="jm-d-flex jm-justify-content-evenly jm-align-items-center jm-mb-4"
    >
      <div class="result-index" data-test="result-index">{{ resultIndex }}</div>
      <stylist-avatar
        class="jm-mx-4"
        :src="stylist.images.profileImage || defaultProfileImage"
        data-test="stylist-avatar"
      ></stylist-avatar>
      <div class="jm-direction-column header-info-container">
        <span class="jm-mb-1 jm-font-bold" data-test="stylist-name">{{
          fullName
        }}</span>
        <stylist-information
          :age="stylist.age"
          :distance="stylist.distance"
          data-test="stylist-information"
        ></stylist-information>
      </div>
    </div>

    <hr class="jm-my-4" />

    <div
      class="kpi-container jm-justify-center jm-align-items-center jm-text-center jm-d-flex jm-mb-3"
    >
      <kpi-block
        :kpiValue="stylist.timeAtJolimoi"
        kpiLabel="chez Jolimoi"
        data-test="kpi-time-at-jolimoi"
      ></kpi-block>
      <kpi-block
        v-if="stylist.teamSize"
        class="jm-ml-2"
        :kpiValue="stylist.teamSize"
        kpiLabel="partenaires"
        data-test="kpi-team-size"
      ></kpi-block>
    </div>

    <stylist-description
      v-if="showDescriptionComponent"
      class="jm-mb-4"
      :description="stylist.bio"
      :images="stylist.images"
      data-test="stylist-description"
    />

    <div
      class="stylist-tags-container jm-mb-2"
      v-if="tagsSelected.length"
      data-test="stylist-tags-container"
    >
      <stylist-tags
        :tags="tagsSelected"
        data-test="stylist-tags"
      ></stylist-tags>
    </div>

    <div class="jm-mb-2">
      <BaseButton
        data-test="submit-btn"
        :loading="loadingSubmit"
        @click="confirmStylist(stylist)"
        class="jm-font-bold jm-uppercase"
        >Je contacte</BaseButton
      >
    </div>
  </div>
</template>
<script>
import { makeSponsorSelection } from '@/store/store.js'
import BaseButton from '@/components/molecules/BaseButton.vue'
import KpiBlock from '@/components/molecules/KpiBlock.vue'
import StylistAvatar from '@/components/molecules/StylistAvatar.vue'
import StylistDescription from '@/components/organisms/StylistDescription.vue'
import StylistInformation from '@/components/molecules/StylistInformation.vue'
import StylistTags from '@/components/molecules/StylistTags.vue'

import defaultProfileImage from '@/assets/images/profile-default.png'

export default {
  name: 'StylistProfileCard',
  components: {
    StylistAvatar,
    StylistInformation,
    StylistTags,
    KpiBlock,
    BaseButton,
    StylistDescription
  },
  props: {
    stylist: {
      type: Object,
      required: true
    },
    resultIndex: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      loadingSubmit: false,
      defaultProfileImage
    }
  },
  computed: {
    fullName() {
      return `${this.stylist.firstname} ${this.stylist.lastname}`
    },
    showDescriptionComponent() {
      return this.stylist.bio || Object.keys(this.stylist.images).length
    },
    tagsSelected() {
      return this.stylist.tags.filter(tag => tag.isSelected)
    }
  },
  methods: {
    async confirmStylist(stylist) {
      try {
        this.loadingSubmit = true
        await makeSponsorSelection(stylist, this.goToPage)
      } catch (error) {
        console.error(error)
        this.toast.error("La styliste n'a pu être selectioné")
      } finally {
        this.loadingSubmit = false
      }
    },
    async goToPage(pageName) {
      await this.$router.push({ name: pageName })
    }
  }
}
</script>

<style lang="scss" scoped>
hr {
  height: 1px;
  background-color: $grey-300;
  border: none;
}
.stylist-card-simple {
  box-sizing: border-box;
  height: 100%;
  margin: 0 auto;
  border-radius: $border-radius-base;
  max-width: $breakpoint-m;

  .result-index {
    align-self: flex-start;
    font-size: $font-size-s;
    flex-grow: 1;
  }
  .header-info-container {
    flex-grow: 1;
  }
}
</style>
